import { isFullyTranslated } from "../utils/locale";

const TRANSLATABLE_FIELDS = ["text", "title", "name", "description"];

export interface ExtractedText {
  key: string;
  enText: string;
}

export function extractTexts(blocks: any[], prefix = "", force = false): ExtractedText[] {
  const results: ExtractedText[] = [];
  blocks.forEach((block, i) => {
    const bk = prefix ? `${prefix}.${i}` : `${i}`;
    for (const field of TRANSLATABLE_FIELDS) {
      const val = block[field];
      if (!val) continue;
      if (!force && isFullyTranslated(val)) continue;
      let enText = "";
      if (typeof val === "string" && val.trim()) enText = val;
      else if (typeof val === "object" && !Array.isArray(val) && val.en?.trim()) enText = val.en;
      if (enText) results.push({ key: `${bk}.${field}`, enText });
    }
    if (Array.isArray(block.content)) {
      results.push(...extractTexts(block.content, `${bk}.content`, force));
    }
    if (Array.isArray(block.items)) {
      block.items.forEach((item: any, j: number) => {
        const ik = `${bk}.items.${j}`;
        for (const field of ["title", "description", "name"]) {
          const val = item[field];
          if (!val) continue;
          if (!force && isFullyTranslated(val)) continue;
          let enText = "";
          if (typeof val === "string" && val.trim()) enText = val;
          else if (typeof val === "object" && !Array.isArray(val) && val.en?.trim()) enText = val.en;
          if (enText) results.push({ key: `${ik}.${field}`, enText });
        }
      });
    }
  });
  return results;
}

export function injectTranslations(
  blocks: any[],
  map: Map<string, Record<string, string>>,
  prefix = ""
): any[] {
  return blocks.map((block, i) => {
    const bk = prefix ? `${prefix}.${i}` : `${i}`;
    let updated = { ...block };
    for (const field of TRANSLATABLE_FIELDS) {
      const t = map.get(`${bk}.${field}`);
      if (!t) continue;
      const val = block[field];
      const en = typeof val === "string" ? val : (val?.en ?? "");
      if (en) updated[field] = { en, ...t };
    }
    if (Array.isArray(block.content)) {
      updated.content = injectTranslations(block.content, map, `${bk}.content`);
    }
    if (Array.isArray(block.items)) {
      updated.items = block.items.map((item: any, j: number) => {
        const ik = `${bk}.items.${j}`;
        let upd = { ...item };
        for (const field of ["title", "description", "name"]) {
          const t = map.get(`${ik}.${field}`);
          if (!t) continue;
          const val = item[field];
          const en = typeof val === "string" ? val : (val?.en ?? "");
          if (en) upd[field] = { en, ...t };
        }
        return upd;
      });
    }
    return updated;
  });
}
